




























import { Vue, Component } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import { EAfterSignStep } from '@signing-page/signing/types/enums/after-sign-step.ts';

@Component({
  components: {
    Button,
  },
  data: () => ({
    EAfterSignStep,
  }),
})
export default class AfterSignOptions extends Vue {
  // We should consider to be able to send in different types of states to be able to AB test this stuff.

  handleOptionPick(option: EAfterSignStep) {
    this.$emit('select', option);
  }
}
